import ButtonLink from '../../common/components/Button/ButtonLink.js'
import Quantity from '../../common/components/Quantity.js'
import {openGoodsReceiptModal} from '../PurchaseOrderListPage/Modals/GoodsReceiptModal/goodsReceiptModalFunctions.js'
import {productDetailURLSelector} from '../ProductDetailPage/productDetailSelectors.js'
import {
  poItemNameSelector,
  poItemSKUSelector,
  poItemQuantitySelector,
  poItemRemainingSelector,
  poItemLocationInWarehouseSelector,
  goodsReceiptSelector,
  poItemSupplierSKUSelector,
  poItemSupplierNoteSelector,
} from '../../data/pos.js'
import {getState, useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'
import {showBarcodeLabelModal} from '../ProductListPage/Modals/BarcodeLabelModal.js'
import LinkButton from '../../common/components/Link/LinkButton.js'
import {PRODUCT_DETAIL_SUPPLIERS_PANEL} from '../../common/constants/Products.js'

export function showGRBarcodeModal(poID, goodsReceiptID, itemIDs) {
  const goodsReceipt = goodsReceiptSelector(getState(), {poID, goodsReceiptID})

  const items = itemIDs
    ? goodsReceipt.items.filter(({id}) => itemIDs.includes(id))
    : goodsReceipt.items

  const skusAndCounts = items.reduce((prev, item) => {
    if (item.quantity > 0) {
      const sku = item.product.sku

      let count = prev.get(sku) || 0

      count += item.quantity

      prev.set(sku, count)
    }

    return prev
  }, new Map())

  const [skus, counts] = [...skusAndCounts].reduce(
    (prev, [sku, count]) => {
      prev[0].push(sku)
      prev[1].push(count)

      return prev
    },
    [[], []],
  )

  showBarcodeLabelModal(skus, counts)
}

export default function GoodsReceiptItem({
  poID,
  goodsReceiptID,
  item,
  isPOLocked,
}) {
  const poItemID = item.po_item_id
  const sku = useSelector((state) => poItemSKUSelector(state, {poID, poItemID}))
  const supplier_sku = useSelector((state) =>
    poItemSupplierSKUSelector(state, {poID, poItemID}),
  )
  const supplier_note = useSelector((state) =>
    poItemSupplierNoteSelector(state, {poID, poItemID}),
  )
  const name = useSelector((state) =>
    poItemNameSelector(state, {poID, poItemID}),
  )
  const quantity = useSelector((state) =>
    poItemQuantitySelector(state, {poID, poItemID}),
  )
  const remaining = useSelector((state) =>
    poItemRemainingSelector(state, {poID, poItemID}),
  )
  const location_in_warehouse = useSelector((state) =>
    poItemLocationInWarehouseSelector(state, {poID, poItemID}),
  )
  const productDetailURL = useSelector((state) =>
    productDetailURLSelector(state, {sku}),
  )

  return (
    <tr key={item.id}>
      <td className="table__td table__td--md">
        <div>
          <LinkButton className="darker word-breaker" href={productDetailURL}>
            <strong className="block">{name}</strong>
            <span className="block">{sku}</span>
          </LinkButton>
        </div>
      </td>
      <td className="table__td table__td--md">
        <LinkButton
          className="darker"
          href={`${productDetailURL}/${PRODUCT_DETAIL_SUPPLIERS_PANEL}`}
        >
          <strong>{supplier_sku}</strong>
        </LinkButton>
        {supplier_note && (
          <div className="divider--top sm fs-n1 lh-md margin-bottom-1">
            <div className="fs-n1 ws-pre-wrap">{supplier_note}</div>
          </div>
        )}
      </td>
      <td className="table__td table__td--md">{location_in_warehouse}</td>
      <td className="table__td table__td--md align-right">
        <div className="fs-00 lh-md">
          <Quantity value={quantity} />
        </div>
      </td>
      <td className="table__td table__td--md align-right">
        <div className="fs-00 lh-md">
          <Quantity value={remaining} />
        </div>
      </td>
      <td className="table__td table__td--md align-right">
        <ButtonLink
          className="fs-00 lh-md border-underline"
          onClick={() => openGoodsReceiptModal(poID, goodsReceiptID, item.id)}
          disabled={isPOLocked}
        >
          <strong>
            <Quantity value={item.quantity} />
          </strong>
        </ButtonLink>
      </td>
      <td className="table__td table__td--md align-right padding-right-0">
        {item.quantity > 0 && (
          <ButtonLink
            className="no-underline"
            title="Print Barcodes for this item in the goods receipt"
            onClick={() => showGRBarcodeModal(poID, goodsReceiptID, [item.id])}
          >
            <Icon
              name="device-printer"
              className="fs-00 lh-md v-align-middle"
            />
          </ButtonLink>
        )}
      </td>
    </tr>
  )
}
